export default {
  snackbar: {
    acceptInvite: "Accepting invite...",
    acceptInviteSuccess: "You are now a member of {{name}}",
    acceptInviteFailed: "Something went wrong :("
  }
};
